import { render, staticRenderFns } from "./Hakim.vue?vue&type=template&id=6da8bb24&scoped=true"
import script from "./Hakim.vue?vue&type=script&lang=js"
export * from "./Hakim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da8bb24",
  null
  
)

export default component.exports